// extracted by mini-css-extract-plugin
module.exports = {"root":"TextSwatch_root__KgxkA","swatchValue":"TextSwatch_swatchValue__U53no","swatchLabel":"TextSwatch_swatchLabel__eI4jp"};